'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import style from './style.module.scss';
import { useEffect } from 'react';

export const CheckButtons = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleClick = (type: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('type', type);
    router.push(`?${params.toString()}`);
  };

  useEffect(() => {
    if (!searchParams.get('type')) {
      handleClick('image');
    }
  }, []);

  const activeButton = searchParams.get('type') === 'image' ? 'image' : 'video';

  return (
    <div className={style.buttons}>
      <button
        className={activeButton === 'image' ? style.active : ''}
        onClick={() => handleClick('image')}
      >
        Изображения
      </button>
      /
      <button
        className={activeButton === 'video' ? style.active : ''}
        onClick={() => handleClick('video')}
      >
        Видео
      </button>
    </div>
  );
};
